const filters = {

    /**
     * 功能：将时间戳按照给定的 时间/日期 格式进行处理
     * @param {Number} date 时间戳 
     * @param {String} fmtExp 时间格式 'hh:ss'
     * @returns {String} 规范后的 时间/日期 字符串
     */
    fmtDate: function(date, fmtExp) {
        var date = new Date(date)
        var o = {
            "M+": date.getMonth() + 1, //月份
            "D+": date.getDate(), //日
            "h+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };


        if (/(y+)/.test(fmtExp)) {
            fmtExp = fmtExp.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            console.log(fmtExp);
        }
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmtExp))
                fmtExp = fmtExp.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmtExp;
    },

    //字符串截取
    ellipsis: function(str, length) {
        var str = str;
        if (!str) return ''
        if (str.length > length) {
            return str.slice(0, length) + '...'
        }
        return str
    },
    //手机号截取
    privateMob: function(str) {
        var str = str;
        if (str === "" || str == null) {
            return (str = "");
        } else {
            return str.substr(0, 3) + "****" + str.substr(7);
        }
    }

}
export default (Vue) => {
    Object.keys(filters).forEach(key => {
        Vue.filter(key, filters[key])
    })
}


//////////////////
// WEBPACK FOOTER
// ./filters.js
// module id = null
// module chunks = 